import styled from "styled-components";

import { PartnerInstitutionKind } from "@ctypes";
import { usePartnerBank } from "@hooks";
import { i18n, Translations } from "@i18n";

const Lockup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  img,
  svg {
    display: block;
  }
`;

export const PartnershipFooter = () => {
  const { partnerBank } = usePartnerBank();

  if (!partnerBank) return null;

  const { logos, accountName, institutionKind } = partnerBank;
  const { Color: PartnerLogo } = logos;

  // Credit unions are NCUA insured rather than FDIC insured.
  const footerKey =
    institutionKind === PartnerInstitutionKind.CreditUnion
      ? Translations.PartnershipFooterCreditUnion
      : Translations.PartnershipFooterBank;

  return (
    <>
      <Lockup>
        <PartnerLogo height={20} />
      </Lockup>
      {i18n.t(footerKey, { bank: accountName })}{" "}
    </>
  );
};
